import { Component, Input } from '@angular/core';
import { UserService } from '../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Publisher } from '../model/publisher.class';
import { Modal } from 'angular2-modal/plugins/bootstrap';

@Component({
    selector: 'app-publisher-detail',
    templateUrl: './publisher.detail.component.html'
})
export class PublisherDetailComponent {
    public publisher: Publisher;
    public showUsers = false;
    public message = '';

    constructor(public userService: UserService, private route: ActivatedRoute, private router: Router, public modal: Modal) {
        this.route.params.subscribe(
            (params) => {
                userService.get(params['id'], 'publisher').subscribe(data => this.publisher = data as Publisher);
            });
    }

    // Schaltet zwischen der Anzeige von Benutzern und Medien um
    toggleView() {
        if (this.showUsers) {
            this.showUsers = false;
        } else {
            this.showUsers = true;
        }
    }

    delete() {
        this.modal.confirm()
            .size('sm')
            .isBlocking(true)
            .showClose(true)
            .keyboard(27)
            .titleHtml('Verlag wirklich löschen?')
            .cancelBtn('Abbrechen')
            .open().then((resultPromise) => {
                return resultPromise.result.then(
                    (result) => {
                        this.userService.delete(this.publisher.publisherId, 'publisher').subscribe(
                            (data) => this.router.navigate(['publisher/list']),
                            (err) => this.message = 'Löschen fehlgeschlagen!');
                    },
                    () => { });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/publisherDetail/publisher.detail.component.ts